var map = {
	"./blue1.png": "55b3",
	"./blue10.png": "9ec3",
	"./blue2.png": "5957",
	"./blue3.png": "e8cf",
	"./blue4.png": "14c2",
	"./blue5.png": "3809",
	"./blue6.png": "7882",
	"./blue7.png": "a0a9",
	"./blue8.png": "1ff7",
	"./blue9.png": "6c5d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "19d1";